const LocalEventTypes = {
    /**
     * This event is triggered by the LayoutManager when initial scripts (JS or CSS) have been loaded.
     * Event receives no parameters.
     * @type {string}
     */
    LAYOUT_MANAGER_INITIAL_SCRIPTS_LOADED: 'LAYOUT_MANAGER_INITIAL_SCRIPTS_LOADED',
    /**
     * This event is triggered by the LayoutManager when an update has been started.
     * The update concerns: css direction and language.
     * Event receives no parameters.
     * @type {string}
     */
    LAYOUT_MANAGER_UPDATE_IN_PROGRESS: 'LAYOUT_MANAGER_UPDATE_IN_PROGRESS',
    /**
     * This event is triggered by the LayoutManager when the css files that defines the CSS direction have been loaded.
     * Event receives no parameters.
     * @type {string}
     */
    LAYOUT_MANAGER_CSS_DIRECTION_UPDATED: 'LAYOUT_MANAGER_CSS_DIRECTION_UPDATED',
    /**
     * This event is triggered by the LayoutManager when the script associated with the language has been loaded.
     * Event receives no parameters.
     * @type {string}
     */
    LAYOUT_MANAGER_LANGUAGE_UPDATED: 'LAYOUT_MANAGER_LANGUAGE_UPDATED',
    /**
     * This event is triggered by the SdkClient when has authenticated with SDK.
     * Event receives no parameters.
     * @type {string}
     */
    SDK_CLIENT_AUTHENTICATED: 'SDK_CLIENT_AUTHENTICATED',
    /**
     * This event is triggered by the SdkClient when the connection has been set with the SDK, but there
     * iis no authentication data (in app config, cookies, ...).
     * Event receives no parameters.
     * @type {string}
     */
    SDK_CLIENT_READY_TO_AUTHENTICATE: 'SDK_CLIENT_READY_TO_AUTHENTICATE',
    /**
     * This event is triggered by the Settings store when the key that has been pressed is matching with a keyboard shortcut
     * Event receives as parameter the matched shortcut.
     * @type {string}
     */
    SHORTCUT_KEY_PRESSED: 'SHORTCUT_KEY_PRESSED',
    /**
     * This event is triggered by the Settings store when the changes related with certain shortcut has been saved.
     * Event receives as parameter the updated shortcut.
     * @type {string}
     */
    SHORTCUT_KEY_SAVED: 'SHORTCUT_KEY_SAVED',
    /**
     * This event is triggered by the MeetingsRoom store when the use has chosen to share a meeting room.
     * Event receives as parameter the meeting room share details.
     * @type {string}
     */
    MEETING_ROOM_SHARED: 'MEETING_ROOM_SHARED',
    /**
     * This event is triggered by the MeetingsRoom store when the user wants to create a secure meeting room (video-conf).
     * Event receives as parameter the meeting room details.
     * @type {string}
     */
    MEETING_ROOM_SECURE_CREATED: 'MEETING_ROOM_SECURE_CREATED',
    /**
     * This event is triggered by the UserGroups store when the user has ended the edit/create action
     * by cancelling or saving.
     * Event receives no parameters.
     * @type {string}
     */
    USER_GROUPS_DIALOG_CLOSED: 'USER_GROUPS_DIALOG_CLOSED',
    /**
     * This event is triggered by the UserGroups store when a user group is created.
     * The event will receive no parameters
     */
    USER_GROUP_CREATED: 'USER_GROUP_CREATED',
    /**
     * This event is triggered by the UserGroups store when a user group is updated.
     * The event will receive the updated user group id as parameter
     */
    USER_GROUP_UPDATED: 'USER_GROUP_UPDATED',
    /**
     * This event is triggered by the VideoCallPopup when its firsts rendering has occurred.
     * Event receives as parameters: sessionId and the reference to the pupup content
     */
    VIDEO_CALL_POPUP_OPENED: 'VIDEO_CALL_POPUP_OPENED',
    /**
     * This event is triggered by the VideoStreamingSliceHandler when the state of a streamer object has been changed.
     * Event receives as parameters:
     * - streamer => the created streamer element which is set in store and has inside reference to its voip stack
     */
    VIDEO_STREAM_STREAMER_UPDATED: 'VIDEO_STREAM_STREAMER_UPDATED',
    /**
     * This event is triggered by the CompanySettingsSliceHandler when the internal data has been initialized (first load).
     * Event receives no parameters.
     */
    COMPANY_SETTINGS_LOADED: 'COMPANY_SETTINGS_LOADED',
    /**
     * This event is triggered by the CompanySettingsSliceHandler when the internal data has been updated based on a
     * CUG message.
     * Event receives no parameters.
     */
    COMPANY_SETTINGS_UPDATED: 'COMPANY_SETTINGS_UPDATED',
    /**
     * This event is triggered by the UserSettingsSliceHandler when a user setting has been updated.
     * The event receives as parameter an object which has: {name: the-name-of-the-chaged-setting, value: the-new-value}
     */
    USER_SETTING_UPDATED: 'USER_SETTING_UPDATED',
    /**
     * This event is triggered by the CompanySettingsSliceHandler when the call FWD. settings have been updated from outside.
     */
    CALL_FWD_SETTINGS_UPDATED_EXTERNALLY: 'CALL_FWD_SETTINGS_UPDATED_EXTERNALLY',
    /**
     * This event is triggered by the PbxDialer component when the user clicks the Call button.
     * The event receives as parameter the following object: {phoneNumber: 'string', contact: existing contact || null}
     */
    CALL_OUT_TRIGGERED: 'CALL_OUT_TRIGGERED',
    /**
     * This event is triggered by the TopBarSettingsSliceHandler when the user clicks on a menu item
     */
    MAIN_MENU_ITEM_SELECTED: 'MAIN_MENU_ITEM_SELECTED',
    /**
     * This event is triggered by the EmergenciesMenu component when the user clicks on an Emergency Call button
     */
    EMERGENCY_CALL_TRIGGER: 'EMERGENCY_CALL_TRIGGER',
    /**
     * This event is triggered by the EmergencyMessagePopup component when the user clicks on an Emergency Message button
     */
    EMERGENCY_MESSAGE_TRIGGER: 'EMERGENCY_MESSAGE_TRIGGER',
    /**
     * This event is triggered by the Top Bar component when the user clicks on an active Emergency Message button
     */
    EMERGENCY_MESSAGE_STOP: 'EMERGENCY_MESSAGE_STOP',
    /**
     * This event is triggered by ReachBackRequestsSliceHandler when the user has pressed the PTT button on a RBR item.
     * The event will receive as parameter the RBT request object
     */
    CHANNEL_REACH_BACK_REQUESTS_PTT: 'CHANNEL_REACH_BACK_REQUESTS_PTT',
    /**
     * This event is triggered by the BellNotificationsMenuItem component in order to call the legacy bell notifications popup
     */
    BELL_NOTIFICATIONS_BUTTON_CLICK: 'BELL_NOTIFICATIONS_BUTTON_CLICK',
    /**
     * This event is triggered when the attachments or processes link is clicked in Storage Quota section.
     * The event receives as parameter the trigger type.
     */
    STORAGE_QUOTA_TRIGGER: 'STORAGE_QUOTA_TRIGGER',
    /**
     * This event is triggered by SoundSettingsSliceHandler when the audio INPUT is updated
     * The event receives as parameter an object with two properties:
     * - oldDeviceId
     * - newDeviceId
     */
    AUDIO_CONFIGURATION_INPUT_UPDATED: 'AUDIO_CONFIGURATION_INPUT_UPDATED',
    /**
     * This event is triggered by SoundSettingsSliceHandler when the audio OUTPUT is updated
     * The event receives as parameter an object with two properties:
     * - oldDeviceId
     * - newDeviceId
     */
    AUDIO_CONFIGURATION_OUTPUT_UPDATED: 'AUDIO_CONFIGURATION_OUTPUT_UPDATED',
    /**
     * This event is used to trigger an iframe update in legacy when the list of my rules packages is updated.
     * The event receives no parameters.
     */
    MY_RULES_PACKAGES_LIST_UPDATED: 'MY_RULES_PACKAGES_LIST_UPDATED',
    /**
     * This event is triggered when the my tools menu item is clicked and needs to display the selected package.
     * The event receives no parameters.
     */
    MY_RULES_PACKAGE_SELECTED: 'MY_RULES_PACKAGE_SELECTED',
    /**
     * This event is triggered by the ContactsStore when user has chosen a menu action from the contextual menu of a contact
     * The vent will receive as parameter an object with following properties:
     * - action
     * - contact: user or group
     */
    SINGLE_CONTACT_ACTION_TRIGGERED: 'SINGLE_CONTACT_ACTION_TRIGGERED',
    /**
     * This event is triggered by the ContactsStore when user has chosen a menu action from the contextual menu of a contact
     * The vent will receive as parameter an object with following properties:
     * - action
     * - contacts: users: [], groups: []
     */
    MULTIPLE_CONTACTS_ACTION_TRIGGERED: 'MULTIPLE_CONTACTS_ACTION_TRIGGERED',
    /**
     * This event is triggered by the ContactsStore when user has clicked the Logout action.
     * Event receives no parameters.
     */
    LOGOUT_REQUESTED: 'LOGOUT_REQUESTED',
};
export default LocalEventTypes;
